import React, { useState } from 'react';

function EmergencyTab({ user }) {
  const [calling, setCalling] = useState(null);

  const emergencyContacts = [
    { name: 'Ambulance', number: '108', icon: 'local_hospital', color: '#ef4444', bg: '#fee2e2', desc: 'National Emergency Ambulance' },
    { name: 'Police', number: '100', icon: 'local_police', color: '#3b82f6', bg: '#dbeafe', desc: 'Police Emergency' },
    { name: 'Fire', number: '101', icon: 'local_fire_department', color: '#f97316', bg: '#ffedd5', desc: 'Fire Emergency' },
    { name: 'Women Helpline', number: '1091', icon: 'support_agent', color: '#8b5cf6', bg: '#ede9fe', desc: 'Women Safety Helpline' },
    { name: 'Disaster', number: '1078', icon: 'crisis_alert', color: '#14b8a6', bg: '#ccfbf1', desc: 'National Disaster Helpline' },
    { name: 'Senior Citizen', number: '14567', icon: 'elderly', color: '#f59e0b', bg: '#fef3c7', desc: 'Senior Citizen Helpline' },
  ];

  const handleCall = (contact) => {
    setCalling(contact);
    window.location.href = `tel:${contact.number}`;
    setTimeout(() => setCalling(null), 3000);
  };

  return (
    <div className="px-4 py-4">
      {/* SOS Banner */}
      <div className="rounded-2xl p-5 mb-5 text-white text-center relative overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #dc2626, #ef4444)' }}>
        <div className="absolute inset-0 opacity-10"
          style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '20px 20px' }}></div>
        <div className="relative z-10">
          <span className="material-symbols-outlined text-white mb-2 block"
            style={{ fontSize: '40px', fontVariationSettings: '"FILL" 1' }}>emergency</span>
          <h2 className="text-2xl font-black mb-1">Emergency Calls</h2>
          <p className="text-white/80 text-sm">Tap any button to call instantly</p>
        </div>
      </div>

      {/* Patient Info */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 mb-5">
        <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">YOUR EMERGENCY INFO</p>
        <div className="space-y-2">
          <div className="flex justify-between">
            <span className="text-xs text-gray-500">Name</span>
            <span className="text-xs font-bold text-[#191c1e]">{user?.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-xs text-gray-500">Patient ID</span>
            <span className="text-xs font-bold text-[#003d9b]">{user?.patientUid || 'MHJ-XXXX'}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-xs text-gray-500">Phone</span>
            <span className="text-xs font-bold text-[#191c1e]">{user?.phone || 'N/A'}</span>
          </div>
        </div>
        <p className="text-xs text-gray-400 mt-3 italic">Share your Patient ID with responders to access your medical records</p>
      </div>

      {/* Emergency Numbers */}
      <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">EMERGENCY NUMBERS</p>
      <div className="grid grid-cols-2 gap-3">
        {emergencyContacts.map(contact => (
          <button key={contact.number} onClick={() => handleCall(contact)}
            className="bg-white rounded-2xl p-4 border border-gray-100 shadow-sm flex flex-col items-center text-center active:scale-95 transition-all gap-2"
            style={{ borderTop: `3px solid ${contact.color}` }}>
            <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: contact.bg }}>
              <span className="material-symbols-outlined" style={{ fontSize: '24px', color: contact.color, fontVariationSettings: '"FILL" 1' }}>{contact.icon}</span>
            </div>
            <div>
              <p className="font-black text-[#191c1e] text-sm">{contact.name}</p>
              <p className="text-lg font-black" style={{ color: contact.color }}>{contact.number}</p>
              <p className="text-xs text-gray-400 leading-tight">{contact.desc}</p>
            </div>
            {calling?.number === contact.number ? (
              <span className="text-xs font-bold text-green-600 bg-green-50 px-3 py-1 rounded-full">📞 Calling...</span>
            ) : (
              <span className="text-xs font-bold px-3 py-1 rounded-full" style={{ background: contact.bg, color: contact.color }}>Tap to Call</span>
            )}
          </button>
        ))}
      </div>

      <div className="mt-4 bg-amber-50 border border-amber-200 rounded-2xl p-4 flex gap-3">
        <span className="material-symbols-outlined text-amber-600 shrink-0" style={{ fontSize: '20px', fontVariationSettings: '"FILL" 1' }}>warning</span>
        <p className="text-xs text-amber-700 leading-relaxed">These are government emergency helplines. Use only in genuine emergencies. Misuse is a punishable offence.</p>
      </div>
    </div>
  );
}

export default EmergencyTab;